import "./DCSlug.css";

type DCSlugProps = {
    content?: string;
    children?: React.ReactNode;
}

export const DCSlug = ({content, children}: DCSlugProps) => {
    return (
        <div className="dc-slug">
            {content && <span>{content}</span>}
            {children}
        </div>
    );
}